{
  "endTime": "Päättymisaika",
  "startTime": "Alkamisaika",
  "time": "Aika"
}
